import { useState, useEffect, useMemo } from 'react';
import { Tabs, Pagination, Modal, Input, Select, Button, ConfigProvider, PaginationProps } from 'antd';
import { EyeOutlined, SettingOutlined, FilterOutlined, FilterFilled } from '@ant-design/icons';
import '../../../styles.scss';
import { TabsProps } from 'antd/lib';
import MegaTable from '../../../../../components/MagaTableV2';
import { useSelector } from 'react-redux';
import { selectorInfoUser } from '../../../../../store/slices/infoUserSlice';
import { selectorUnitByUserPermission } from '../../../../../store/slices/UnitByUserPermission';
import { formatNumber, mixGetV1 } from '../../../../../services/mixin';
import viVN from "antd/locale/vi_VN";
import { AgGridReact } from 'ag-grid-react';
import { NodataTable } from '../../../../../components/NoDataTable';
import ServiceMaintenanceInvoiceDetail from './Components/ServiceMaintenanceInvoiceDetail';
import { FlattenedField } from '../../../../CustomersV2/indexV2';
import { FieldsUpdate, getListFieldsByCustomer, getListServiceInvoices, ICustomer, ListField, updateFieldUser } from '../../../../../api/Customer_V2/customerApi_V2';
import { IPagination } from '../../../../Customers/CustomerGroup/Component/AddGroup/AddNewGroup';
import { ColDef } from 'ag-grid-community';
import { ColumnKey } from '../../../../Customers/Tabs/CarListCardClone';
import { CustomLoadingOverlayTable, dataPagination, flattenFields, getWidthFromHeaderV2, NOOP, renderValueAsJSX } from '../../../../../until';
import useLoading from '../../../../../hook/useLoading';
import useToast from '../../../../../hook/useToast';
import useDebounce from '../../../../../hook/useDebounce';
import { selectorCategoryCarIds } from '../../../../../store/slices/categoryCarSlice';
import TabServiceMaintenanceInvoiceTabDetail from './Components/ServiceMaintenanceInvoiceDetail';
import ServiceRecordFeilds from '../../ServiceRecords/Components/ServiceRecordFeilds';
import { FIELDTYPE, NO_VIEW } from '../../../../../services/data';
import useThrottle from '../../../../../hook/useThrottle';
import { ICustomerFields } from '../../../../../api/salesSericeCustomer/salesSericeCustomerApi';
import FilterHeaderTabServiceMaintenanceInvoice from './Components/FilterHeaderTabServiceMaintenanceInvoice';
import { useNavigate } from 'react-router-dom';
import { IDataDefaulFilterCar } from '../../ServiceRecords/Components/FilterHeaderCar/FilterHeaderCar';
import { generateColumnsFromCodesAgGridReactRecordCar } from '../../ServiceRecords/ContactInformation';
type PaginationKey = "info";
interface IDataFilterActive {
    info: FlattenedField[];
}

interface IDataFilterNoActive {
    info: ListField[];
}

const EMPTY_GROUP = {
    info: [],
};
export interface IFilterListTabServiceMaintenanceInvoice {
    chassisNo?: number[];
    branchId?: number[];
}

export interface IFilterListTabServiceMaintenanceInvoice {
    chassisNo?: number[];
    branchId?: number[];
}

type HeaderActions = {
    setDataFilterList: (dataFilterList: IFilterListTabServiceMaintenanceInvoice) => void;
};

type FilterHeaderExtras = {
    dataFilterList?: IFilterListTabServiceMaintenanceInvoice;
    setDataFilterList: (dataFilterList: IFilterListTabServiceMaintenanceInvoice) => void;
};



interface Props {
    loadingTable: boolean
    dataFieldsActive: FlattenedField[]
    idCustomer?: number
    data: ICustomer[]
    dataFilterList?: IDataDefaulFilterCar
    pagination: IPagination


    setDataFilterList: React.Dispatch<React.SetStateAction<IDataDefaulFilterCar>>
    onPaginationChange: (page: number, pageSize: number) => void
}

const TabServiceMaintenanceInvoice: React.FC<Props> = ({
    loadingTable,
    dataFieldsActive, pagination,
    idCustomer, dataFilterList, data,
    setDataFilterList, onPaginationChange
}) => {
    useEffect(() => {
        gListFieldsActive()
    }, [])
    const navigator = useNavigate()

    const pushLoading = useLoading()
    const pushToast = useToast();
    const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)
    const { id, unitTemp } = useSelector(selectorInfoUser) // đợn vị dc chọn

    const [loadingTableDetail, setLoadingTableDetail] = useState(false)
    const [isSettingShow, setSettingShow] = useState(false)

    const [activeTab, setActiveTab] = useState<PaginationKey>("info");
    const [dataFieldsServiceMaintenanceActive, setDataFieldsServiceMaintenanceActive] = useState<IDataFilterActive>(EMPTY_GROUP);
    const [dataFieldsServiceMaintenanceNoActive, setDataFieldsServiceMaintenanceNoActive] = useState<IDataFilterNoActive>(EMPTY_GROUP);
    const [columnsMapShow, setColumnsMapShow] = useState<ColumnKey[]>([]);
    const [paginationMap, setPaginationMap] = useState<Record<PaginationKey, IPagination>>({
        info: { current: 1, pageSize: 10, total: 0 },
    });
    const [loadedTabs, setLoadedTabs] = useState<Record<PaginationKey, boolean>>({
        info: false,
    });


    const [selectId, setSelectId] = useState<number>()
    const [infoCar, setInfoCar] = useState<ICustomer[]>([]);

    //#region Cấu hình bảng
    const actionColumn: ColDef = {
        headerName: 'Hành động',
        field: 'action',
        colId: 'action',
        width: 180,
        resizable: false,
        suppressMovable: true,
        lockPosition: 'left',
        headerComponentParams: {
            template: '<span class="w-full flex items-center justify-center">Hành động</span>'
        },
        cellRenderer: (params: any) => {
            return (
                <div className='d-flex gap-2 justify-center align-center  h-full px-1'>
                    {
                        permittedCategoryCarIds?.includes(params?.data?.categoryCarId ?? -1)
                            ?
                            <EyeOutlined
                                className='text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer'
                                onClick={(e) => {
                                    e.stopPropagation(); // 🔴 chặn click lan lên row
                                    const currentId = params.data?.id;
                                    if (currentId === selectId) {
                                        params.node.setSelected(false); // ❌ bỏ chọn
                                        setSelectId(undefined);         // reset
                                        return;
                                    }

                                    params.node.setSelected(true);    // ✅ chọn mới
                                    setSelectId(currentId);
                                }}
                            />
                            :
                            ''
                    }

                </div>

            )
        },
    }

    const memoizedColumnDefs = useMemo(() => {
        return generateColumnsFromCodesAgGridReactRecordCar(
            columnsMapShow,
            dataFieldsActive,
            actionColumn,
            () => { },
            {
                setDataFilterList, // 👈 function thật của bạn
            },
            ["own_chassis_no", "branch_service_provider"], // 👈 listFilterIcon
            dataFilterList, idCustomer,
            ['contact_name']

        );
    }, [columnsMapShow, dataFieldsActive, selectId, dataFilterList, idCustomer]);

    const tableData = useMemo(() => {
        return data.map((item) => {
            const fieldValues = item.fields.reduce(
                (acc: Record<string, any>, field) => {
                    acc[field.fieldCode] = field.view === false ? NO_VIEW : field.value;
                    return acc;
                },
                {}
            );


            return {
                ...item,
                key: item.id.toString(),
                ...fieldValues
            };
        });
    }, [data]);

    useEffect(() => {
        const codes = dataFieldsActive.map((f) => f.fieldCode);
        setColumnsMapShow(codes);
    }, [dataFieldsActive]);

    //#endregion

    const gListFieldsActive = async () => {
        const [serviceMaintenanceInvoiceTabDetailRes] =
            await Promise.all([
                getListFieldsByCustomer(FIELDTYPE.ServiceMaintenanceInvoiceDetail, 1),
            ]);
        const flattenedFieldsContactInformation = flattenFields(serviceMaintenanceInvoiceTabDetailRes?.data ?? []);

        setDataFieldsServiceMaintenanceActive({
            info: flattenedFieldsContactInformation,

        });

        gListFieldsNotActive();
    };

    const gListFieldsNotActive = async () => {
        const [serviceMaintenanceInvoiceTabDetailNoActiveRes] =
            await Promise.all([
                getListFieldsByCustomer(FIELDTYPE.ServiceMaintenanceInvoiceDetail, 0),
            ]);

        setDataFieldsServiceMaintenanceNoActive({
            info: serviceMaintenanceInvoiceTabDetailNoActiveRes?.data ?? [],
        })
    };


    const gListServiceInvoicesDetail = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
        if (!idCustomer || !selectId) {
            setInfoCar([]);
            return
        };
        setLoadingTableDetail(true)
        const result = await getListServiceInvoices(
            idCustomer, unitTemp, permittedCategoryCarIds,
            selectId, pageSize, pageCurent
        )
        if (result?.status) {
            setInfoCar(result.data)
            setPaginationMap(prev => ({
                ...prev,
                info: {
                    current: pageCurent,
                    pageSize,
                    total: result.total,
                },
            }));
        } else {
            pushToast(result?.message, "warning")
        }
        // 🔥 QUAN TRỌNG
        setLoadedTabs(prev => ({
            ...prev,
            info: true,
        }));
        setLoadingTableDetail(false)
    }, 1000)

    const onSaveVisibleFields = useThrottle(async (dataFilterActive: FlattenedField[], dataFilterNoActive: ListField[]) => {
        let result: any;
        const activeFields: FieldsUpdate[] = dataFilterActive.map(item => ({
            fieldId: item.id,
            isActive: 1, // hoặc true tùy bạn muốn mặc định là gì
        }));
        const allFieldsDefaultInactive: FieldsUpdate[] = dataFilterNoActive.flatMap(group =>
            group.fields.map(field => ({
                fieldId: field.id,
                isActive: 0,
            }))
        );
        const listActiveFields = activeFields.concat(allFieldsDefaultInactive)

        switch (activeTab) {

            case 'info': {
                result = await updateFieldUser(id, FIELDTYPE.ServiceMaintenanceInvoiceDetail, undefined, listActiveFields)
                break;
            }

            default:
                break;
        }

        if (result?.status) {
            pushToast(result?.message, "success")
            setSettingShow(false)

            if (dataFilterActive && dataFilterNoActive) {
                setDataFieldsServiceMaintenanceActive(prev => ({
                    ...prev,
                    [activeTab]: dataFilterActive ?? [],
                }));

                setDataFieldsServiceMaintenanceNoActive(prev => ({
                    ...prev,
                    [activeTab]: dataFilterNoActive ?? [],
                }));
            }

        } else {
            pushToast(result?.message, "warning")
        }
    }, 2000)

    const onPaginationChangeTab: PaginationProps['onChange'] = (pageNumber, pageSize) => {
        switch (activeTab) {
            case "info": {
                gListServiceInvoicesDetail(pageNumber, pageSize)
                break;
            }
            default:
                break;
        }
    }

    useEffect(() => {
        if (!selectId) {
            // 1️⃣ RESET
            setInfoCar([]);

            setLoadedTabs({
                info: false,
            });
            setPaginationMap({
                info: { current: 1, pageSize: 10, total: 0 },

            });

            return;
        }

        // 2️⃣ GỌI API ĐÚNG TAB
        switch (activeTab) {
            case "info":
                gListServiceInvoicesDetail();
                break;
            default:
                break
        }
    }, [selectId]);

    useEffect(() => {
        if (!selectId) return;
        switch (activeTab) {
            case "info":
                if (!loadedTabs.info) gListServiceInvoicesDetail();
                break;
            default:
                break
        }
    }, [activeTab]);

    useEffect(() => {
        setInfoCar([]);
        setSelectId(undefined);
    }, [idCustomer])

    return (
        <>
            {
                isSettingShow ?
                    <ServiceRecordFeilds
                        isSettingShow={isSettingShow}
                        recordId={1}
                        type={0}

                        dataFilterActive={dataFieldsServiceMaintenanceActive[activeTab]}
                        dataFilterNoActive={dataFieldsServiceMaintenanceNoActive[activeTab]}

                        onSaveVisibleFields={onSaveVisibleFields}
                        onClose={() => setSettingShow(false)}
                    /> :
                    null
            }
            <div className="custom-page-css w-full flex flex-col items-center justify-between gap-3 pt-3">
                <div className="ag-theme-alpine custom-table-ag custom-css-table"
                    // style={{ width: '100%', height: 610 }}
                    style={{ width: '100%', height: tableData.length === 0 ? 250 : tableData.length < 10 ? tableData.length * 65 + 65 : 650 }}
                >

                    <AgGridReact
                        className="my-auto-height-grid"
                        getRowStyle={(params: any) => ({
                            backgroundColor: params?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
                        })}
                        rowData={tableData}
                        columnDefs={memoizedColumnDefs}
                        rowHeight={55}
                        overlayNoRowsTemplate={NodataTable}
                        loading={loadingTable}
                        loadingOverlayComponent={CustomLoadingOverlayTable}
                        // onGridReady={(params) => {
                        //     params.api.sizeColumnsToFit();
                        // }}

                        /* Selection – CHỈ CHO PHÉP SELECT BẰNG CODE */
                        rowSelection="single"
                        suppressRowClickSelection={true}

                        /* Performance */
                        suppressColumnVirtualisation={true}
                        suppressRowVirtualisation={false}
                        enableCellTextSelection={true}
                        ensureDomOrder={true}
                        debounceVerticalScrollbar={true}
                        suppressScrollOnNewData={true}
                        suppressDragLeaveHidesColumns={true}

                        /* Scroll */
                        rowBuffer={20}
                        maxBlocksInCache={10}
                        infiniteInitialRowCount={1000}
                    />
                </div>
                <ConfigProvider
                    locale={viVN}
                >
                    <div className="pagination-block">
                        <Pagination
                            showSizeChanger
                            current={pagination.current}
                            pageSize={pagination.pageSize}
                            total={pagination.total}
                            itemRender={(page, type, originalElement) => {
                                // Chỉ custom khi là nút số trang
                                if (type === 'page') {
                                    return <span>{formatNumber(page)}</span>;
                                }
                                // prev / next / jump-prev / jump-next giữ nguyên
                                return originalElement;
                            }}
                            showTotal={() =>
                                `Tổng cộng ${dataPagination(
                                    pagination.total,
                                    pagination.pageSize,
                                    pagination.current
                                ).totalPage} trang`
                            }
                            className="rs-pagination"
                            onChange={onPaginationChange}
                        />
                    </div>
                </ConfigProvider>
                {/* {selectId ? ( */}
                <div className="custom-page-css w-full flex items-center justify-between gap-3 pt-3 relative">
                    <Tabs
                        defaultActiveKey="1"
                        items={
                            [
                                {
                                    key: '1',
                                    label: <span className='custom-page-css font-light text-lg'>Chi tiết</span>,
                                    children:
                                        <TabServiceMaintenanceInvoiceTabDetail
                                            loadingTableDetail={loadingTableDetail}
                                            dataFieldsActive={dataFieldsServiceMaintenanceActive.info}
                                            pagination={paginationMap.info}
                                            data={infoCar}

                                            onPaginationChange={onPaginationChange}
                                        />
                                    // <></>
                                    ,
                                },
                            ]
                        }
                        className='w-full'
                    />
                    <div className="custom-page-css absolute top-4 right-0">
                        <div className='settingCol'>
                            <div className='ctr-col-setting'
                                onClick={() => setSettingShow(true)}
                            >
                                <SettingOutlined />
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )

}

export default TabServiceMaintenanceInvoice
